import { unix } from '@lib/datetime';

/**
 * Add burst cache via parameter to a given url
 * @param url
 */
export function burstCacheUrl(url: string): string {
    return `${url}${url?.includes('?') ? '&' : '?'}_t=${unix()}`;
}
